<template>
  <div>
    <b-row class="justify-content-start">
      <b-col md="2" class="w-100" v-if="type == 'BULK'">
        <back-button :returnUrl="returnUrl"></back-button>
      </b-col>
    </b-row>
    <b-row class="mb-5 justify-content-start m-0">
      <!-- Left section filtre -->
<!--      <b-col cols="4" lg="2" xl="2" class="mt-2">-->
<!--        <b-button class="btnFilter"-->
<!--          @click="displayFilter = !displayFilter">-->
<!--          <i v-if="displayFilter" class="fa-light fa-minus"></i>-->
<!--          <i v-else class="fa-light fa-plus"></i>-->
<!--          {{ $t('filter.fltr') }}-->
<!--        </b-button>-->
<!--      </b-col>-->
      <b-col cols="4" lg="2" xl="2" class="mt-2 pl-0">
        <b-button class="btnFilter"
          @click="refreshInbox()">
          <i class="fa-light fa-rotate-right"></i>
          {{ $t('common.rfrsh') }}
        </b-button>
      </b-col>
    </b-row>
    <b-row class="min-w-100 justify-content-start align-items-center" >
      <!--Filtre IBAN -->
      <b-col v-if="displayFilter" sm="6" lg="3" cols="12" class="filter-item mb-5">
        <label class="filter-item-title" for="filter-iban">{{ $t('account_tb.name') }}</label>
        <span class="filter-item-content">
          <input v-model.trim="Name"
                 id="filter-iban"
                 type="text"
                 :class="{'filter-item-input': true, 'filter-item-input-complete': Name}"
                 :placeholder="$t('account_tb.name')"
                 style="width: 100%">
        </span>
      </b-col>
    </b-row>
    <b-row class="min-w-100 justify-content-end mb-5" v-if="displayFilter">
      <!-- Bouton Effacer et Appliquer -->
      <b-col lg="3" cols="12" class="d-flex flex-row-reverse mt-3">
        <b-button size="sm"
          @click="applyFilter()">
          {{ $t('common.srch') }}
        </b-button>
        <b-button class="mr-3" size="sm"
          @click="clearFilterFields"
          :disabled="!hasInputFilter">
          {{ $t('filter.clr_fltr_field') }}
        </b-button>
      </b-col>
    </b-row>
   <div class="d-flex justify-content-end" v-if="TestCaseTBList.length > 0">
      <b-button class="btnFilter_2"
        @click="generatePDF()">
        <i class="fa-light fa-upload fs-14px"></i>
        <span class="fab-label">{{ $t('common.extract_page') }}</span>
      </b-button>
    </div>
    <spinner v-if="activateSpinner"></spinner>
    <div v-else-if="TestCaseTBList.length > 0" >
      <chart-pie-stat :stat="TestCaseTBList"></chart-pie-stat>

      <form-accordion
          :open="false"
          v-for="(testCase, index) in TestCaseTBList"
          :key="index"
          :title="`Test ${index + 1} : ${testCase.CaseSumary}`"
          :isTitleUpperCase="false" class=" my-5 p-0">

        <b-table hover
                 class="table table-striped"
                 style="margin-bottom:0"
                 :fields="fields"
                 :items="[testCase]"
                 :empty-text="$t('common.security.no_result')">
          <template #cell(IdDataset)="data">
            <div class="text-ellipsis">Dataset {{ index + 1 }} : {{ data.item.DescriptionCase }}</div>
          </template>
          <template #cell(Status)="data">
            <div class="text-ellipsis">{{ data.item.Status || 'N/A' }}</div>
          </template>
          <template #cell(ExecutionDate)="data">
            <div class="text-ellipsis">{{ data.item.ExecutionDate || 'Non exécuté' }}</div>
          </template>
        </b-table>
      </form-accordion>
    </div>
    <div v-else class="d-flex justify-content-center">
      <span class="noResult">
        {{ $t('common.no_result') }}
      </span>
    </div>
    <b-row class="mt-5">
      <b-col cols="12">
        <cm-pagination
          :maxResultsByPage="paginationObject.maxResults"
          :firstIndex="paginationObject.firstIndex"
          :nbResultsTotal="paginationObject.nbResultsTotal"
          :refreshEvent="paginationObject.refresh">
        </cm-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import BackButton from "@/components/common/backButton.vue"
import ChartPieStat from "@/pages/testCaseReport/ChartPieStat.vue"
import FormAccordion from "@/components/common/FormAccordion.vue"
import { jsPDF } from "jspdf"
import "jspdf-autotable"


export default {
  name: 'TestCaseReportList',
  components: {
    FormAccordion,
    ChartPieStat,
    BackButton,
    'cm-pagination': Pagination,
    'spinner': Spinner,
    'datetime-picker-custom': dateTimePicker,
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    type: {
      default: 'DDV',
      type: String
    },
    id: {
      default: 'NULL',
      type: String
    }
  },
  computed: {
    fields () {
      let fields
      fields = [
        { key: 'IdDataset', label: this.$i18n.t('account_tb.id_dataset'), class: 'text-center', sortable: false },
        { key: 'Status', label: this.$i18n.t('account_tb.status_report'), class: 'text-center', sortable: false },
        { key: 'ExecutionDate', label: this.$i18n.t('account_tb.execution_date'), class: 'text-center', sortable: false },
      ]

      return fields
    },
    company_nameDirection () {
      return ((this.sortField === 'company_name' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    statusVerificationDirection () {
      return ((this.sortField === 'statusVerification' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    activeDirection () {
      return ((this.sortField === 'active' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    hasInputFilter () {
      if (
          this.Name ||
          this.Result ) {
        return true
      }
      return false
    },
  },
  data () {
    return {
      TestCaseTBList: {
        type: Array,
        required: true
      },
      isMandatoryFieldMiss: true,
      activateSpinner: false,
      displayFilter: false,
      filterBy: '',
      hasDefaultFilter: false,
      statusVerification: '',
      VopProvider: '',
      Result: '',
      Name: '',
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
    }
  },
  created () {
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start',
      navTitle: 'Tracking',
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)

    this.filterTypeGet = this.filterType
    this.$bus.emit('right-panel-set-feature', 'filter-messages')
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    that.$engine.firstOn().tracking.cleanFilterCondition()
  },
  methods: {
    applyFilter (filterConditions = {}) {
      if(this.tabName !== 2 && this.dateBegin === ''){
        this.isMandatoryFieldMiss = false
        return
      }
      this.isMandatoryFieldMiss = false
      this.TestCaseTBList = []
      this.TestCaseTBStat = []
      let that = this
      this.filterTypeGet = 'list'

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0
      this.activateSpinner = true
      this.$engine.firstOn().tracking.cleanFilterCondition()

      filterConditions.Name = this.Name.trim()

      this.$engine.firstOn().accountTB.getAccountTB(
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.countTestCaseTBs
        that.paginationObject.nbResults = resp.data.accounts.length
        requests = resp.data.accounts
        that.updateInbox(requests)
        // this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    clearFilterFields () {
      this.isMandatoryFieldMiss = true
      this.paginationObject = {}
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['maxResults'] = 15
      this.paginationObject['nbResultsTotal'] = 0
      this.paginationObject['refresh'] = 'direct-inbox-filtered'
      this.Name = ''
      this.communicateChange()
      this.TestCaseTBList = []
      this.TestCaseTBStat = []
      this.applyFilter()
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.firstOn().settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.firstOn().settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    fetchTestTB() {
      this.pageCounter = 0
      this.activateSpinner = true
      let that = this
      that.$engine.firstOn().usercompany.idUserAcc = this.idUserAcc
      this.UsersList = []
      let filterConditions = {
        Report: 1,
      }
      that.$engine.firstOn().accountTB.getTestTB(
          filterConditions
      )
          .then(resp => {
            this.TestCaseTBList = resp.data.Tests || []
            console.log(this.TestCaseTBList)
            this.activateSpinnerTest = false

            that.activateSpinner = false
          })
          .catch(error => {
            this.activateSpinner = false
            errorMessageAlert(error, that, that.$i18n)
          })
    },
    onRefresh () {
      this.fetchTestTB()
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    refreshInbox () {
      this.onRefresh()
    },
    activateDetail (id) {
      let that = this
      loadPage(that, {url: '/accountTBdetails/' + id})
    },
    reOrderBy (column) {
      this.TestCaseTBList = []
      this.TestCaseTBStat = []
      let that = this
      if (this.sortField === column) {
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sortField = column
        switch (column) {
          case 'dateAction':
            this.sortDirection = 'DESC'
        }
      }
      let filterConditions

      // if (this.id !== 'NULL'){
      //   filterConditions.IdBulk = this.id
      // }
      this.$engine.firstOn().accountTB.getAccountTB(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.countTestCaseTBs
        that.paginationObject.nbResults = resp.data.tracks.length
        requests = resp.data
        that.updateInbox(requests, false)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    updateInbox (requests, noAttach = false) {
      console.log('updateInbox', requests)
      this.TestCaseTBList = requests.accounts
      this.TestCaseTBStat = requests.stat
      if (requests.accounts.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    generatePDF() {
      const doc = new jsPDF();

      // Ajouter le graphique en haut
      // const pieChartCanvas = document.getElementById("pie-chart")
      // if (pieChartCanvas && pieChartCanvas.toDataURL) {
      //   const chartImage = pieChartCanvas.toDataURL("image/png", 1.0)
      //   doc.addImage(chartImage, "PNG", 14, 15, 180, 80)
      // } else {
      //   console.warn("Le canvas du PieChart n'a pas été trouvé !")
      // }

      // Titre du rapport
      doc.setFontSize(18)
      doc.text(this.$t('account_tb.report_test_cases'), 14, 15)

      let yOffset = 25 // Position de départ après le graphique

      // **Regrouper les Test Cases (resp et req) par IdTestCase**
      const groupedTestCases = {}
      this.TestCaseTBList.forEach(testCase => {
        if (!groupedTestCases[testCase.IdTestCase]) {
          groupedTestCases[testCase.IdTestCase] = {
            IdTestCase: testCase.IdTestCase,
            CaseSumary: testCase.CaseSumary,
            Type: testCase.Type, // 'resp' ou 'req'
            Status: testCase.Status,
            ExecutionDate: testCase.ExecutionDate,
            Datasets: [] // Liste des datasets associés
          }
        }
        // Ajouter le dataset s'il existe
        groupedTestCases[testCase.IdTestCase].Datasets.push([
          testCase.IdDataset,
          testCase.DescriptionCase || "N/A",
          testCase.Status || "N/A",
          testCase.ExecutionDate || "N/A"
        ])
      })

      // **Séparer les Test Cases par type (resp et req)**
      const respCases = Object.values(groupedTestCases).filter(tc => tc.Type === "resp")
      const reqCases = Object.values(groupedTestCases).filter(tc => tc.Type === "req")

      // **Fonction pour générer un tableau de Test Cases**
      const generateTestCaseTable = (title, testCases) => {
        if (testCases.length === 0) return

        doc.setFontSize(14)
        doc.text(title, 14, yOffset)
        yOffset += 6

        const tableData = testCases.map(test => [
          test.IdTestCase,
          test.CaseSumary || "N/A",
          test.Status || "N/A",
          test.ExecutionDate || "N/A"
        ])

        doc.autoTable({
          head: [[this.$t('account_tb.test_case_id'), this.$t('account_tb.description'), this.$t('account_tb.status_report'), this.$t('account_tb.execution_date')]],
          body: tableData,
          startY: yOffset,
          theme: "striped",
          margin: { left: 14, right: 14 },
          styles: { fontSize: 10 },
        })

        yOffset = doc.lastAutoTable.finalY + 10; // Ajustement de position
      }

      // **Générer le tableau des Test Cases pour 'resp' et 'req'**
      generateTestCaseTable(this.$t('account_tb.type_case_resp'), respCases)
      generateTestCaseTable(this.$t('account_tb.type_case_req'), reqCases)

      // Ajout d'une section pour les détails des Test Cases et leurs Datasets
      doc.setFontSize(16)
      doc.text(this.$t('account_tb.details_test_case_and_dataset'), 14, yOffset)
      yOffset += 10

      // **Générer les tableaux Test Case → Dataset**
      Object.values(groupedTestCases).forEach(testCase => {
        doc.setFontSize(12)
        doc.text(this.$t('account_tb.test_case_id') + `: ${testCase.IdTestCase} - ${testCase.CaseSumary}`, 14, yOffset)
        yOffset += 6

        doc.autoTable({
          head: [[this.$t('account_tb.id_dataset'), this.$t('account_tb.description'), this.$t('account_tb.status_report'), this.$t('account_tb.execution_date')]],
          body: testCase.Datasets,
          startY: yOffset,
          theme: "grid",
          margin: { left: 20, right: 14 },
          styles: { fontSize: 10 },
        })

        yOffset = doc.lastAutoTable.finalY + 12;
      })

      // Enregistrer le PDF
      doc.save(this.$t('account_tb.report_test_cases_pdf') + ".pdf")
    }






  }
}
</script>

<style scoped>
.result-vignette {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
}

.result-mtch {
  background-color: rgba(0, 143, 57, 0.8);
}

.result-nmtc {
  background-color: rgba(204, 0, 0, 0.8);
}

.result-cmtc {
  background-color: rgba(230, 159, 0, 0.8);
}

.result-noap {
  background-color: rgba(153, 153, 153, 0.8);
}
</style>
